module.exports = __webpack_public_path__ + "img/priority-dispatch.6b42ad4d.png";